import * as React from "react";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { CancelOutlined, AccountBalanceOutlined } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import DeliveryDiningIcon from "@mui/icons-material/DeliveryDining";

const ITEM_HEIGHT = 48;

const options = ["Payment Account", "Delivery Charges"];

const icons = [AccountBalanceOutlined, DeliveryDiningIcon, CancelOutlined];

export default function CityThreeDotMenu({ id, paymentAccountHandler }) {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selectedIndex, setSelectedIndex] = React.useState(0);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (event, menuType) => {
    if (menuType == "PAYMENT_ACCOUNT") {
      paymentAccountHandler(id);
      handleClose();
    } else if (menuType == "DELIVERY_CHARGES") {
      navigate(`/city/${id}/delivery-charges`);
    }
   
  };
  return (
    <div>
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={open ? "long-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="long-menu"
        MenuListProps={{
          "aria-labelledby": "long-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 4.5,
            width: "20ch",
          },
        }}
      >
        <MenuItem
          // selected={option === "Pyxis"}
          onClick={(event) => handleMenuItemClick(event, "PAYMENT_ACCOUNT")}
        >
          <AccountBalanceOutlined
            className="order-split-icon"
            sx={{ width: 24 }}
          />
          Payment Account
        </MenuItem>
        <MenuItem
          // selected={option === "Pyxis"}
          onClick={(event) => handleMenuItemClick(event, "DELIVERY_CHARGES")}
        >
          <DeliveryDiningIcon className="order-split-icon" sx={{ width: 24 }} />
          Delivery Charges
        </MenuItem>
      </Menu>
    </div>
  );
}
